<template>
    <div class="row w-100 search-results mt-lg-4">
        <div class="col-lg-3 filters-bar">
            <filters :filters.sync="filters"></filters>
        </div>
        <div class="col-lg-9">
            <results class="m-2 m-lg-0" :limit="limit" :filters="filters"></results>
        </div>
    </div>
</template>

<script>
    import Filters from '~/components/SearchUsers/Filters'
    import Results from '~/components/SearchUsers/Results'

    export default {

        components: {
            Filters,
            Results
        },

        props: {
            limit: {
                type: Number,
                default: function () {
                    return 0
                }
            }
        },

        data() {

            return {
                filters: {
                    status: 'published',
                    diploma: null,
                    account: 'user',
                    column: 'pictures',
                    order: 'desc',
                    certified: null,
                    profile_rank: null,
                    invited: false,
                    category: null,
                    questionnaire_completed: null,
                    exclude_user_id: this.$auth.loggedIn ? this.$auth.user.id : null
                }
            }
        },

        mounted () {

        }
    }
</script>
